import { Paper } from '@safedns/skydns-ui-react-lib';

import AgentsTable from './AgentsTable';

const Agents = () => {
  return (
    <Paper title="Агенты" sx={{ marginBottom: 24 }}>
      <AgentsTable />
    </Paper>
  );
};

export default Agents;
